import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=46f3b123&scoped=true"
import script from "./Layout.vue?vue&type=script&setup=true&lang=js"
export * from "./Layout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=46f3b123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f3b123",
  null
  
)

export default component.exports